import { LumpSumAmountsCoveredOptions } from 'app/constants/configuration/lumpSumAmountsCoveredOptions'

export const getLumpSumAmountsCoveredOptions = (
  type: number,
): LumpSumAmountsCoveredOptions => {
  let lumpSumAmountsCoveredOptions = LumpSumAmountsCoveredOptions.Hide

  switch (type) {
    case 1:
      lumpSumAmountsCoveredOptions = LumpSumAmountsCoveredOptions.ShowCovered
      break
    case 2:
      lumpSumAmountsCoveredOptions =
        LumpSumAmountsCoveredOptions.ShowSettlementOnLastMonth
      break
    case 3:
      lumpSumAmountsCoveredOptions =
        LumpSumAmountsCoveredOptions.ShowSettlementOnNextPeriod
      break
    case 4:
      lumpSumAmountsCoveredOptions =
        LumpSumAmountsCoveredOptions.ShowSettlementOnEveryMonth
      break
  }

  return lumpSumAmountsCoveredOptions
}
